export type Row = Record<string, unknown>;

export function label(key: string) {
	return key
		.replace(/_/g, " ")
		.replace(/percent/gi, "%")
		.replace(/hyphen/gi, "-")
		.replace(/plus/gi, "+")
		.replace(/^c(?=\d)/i, "")
		.replace(/([a-z])([A-Z])/g, "$1 $2")
		.replace(/^./, (c) => c.toUpperCase());
}
export function display(value: unknown): string {
	if (value == null) return "—";
	if (typeof value === "number") return value.toLocaleString(undefined, { maximumFractionDigits: 2 });
	if (typeof value === "boolean") return value ? "Yes" : "No";
	if (typeof value === "object") return JSON.stringify(value);
	return String(value);
}
export function rowsFrom(data: unknown): Row[] {
	if (data == null) return [];
	if (Array.isArray(data)) return data.map((row) => (row !== null && typeof row === "object" ? row : { value: row }));
	if (typeof data === "object") return [data as Row];
	return [{ value: data }];
}
export function csvCell(value: unknown): string {
	const raw = value == null ? "" : typeof value === "object" ? JSON.stringify(value) : String(value);
	// Spreadsheet formula strings must remain text when exported.
	const safe = typeof value === "string" && /^[\s]*[=+\-@\t\r]/.test(raw) ? "'" + raw : raw;
	return '"' + safe.replace(/"/g, '""') + '"';
}
export function download(rows: Row[], columns: string[], title: string) {
	const csv = [
		columns.map((c) => csvCell(label(c))).join(","),
		...rows.map((row) => columns.map((c) => csvCell(row[c])).join(",")),
	].join("\r\n");
	const url = URL.createObjectURL(new Blob(["\uFEFF", csv], { type: "text/csv;charset=utf-8" }));
	const link = document.createElement("a");
	link.href = url;
	link.download = `${title.replace(/[^\w -]/g, "").slice(0, 80) || "my-view"}.csv`;
	link.click();
	setTimeout(() => URL.revokeObjectURL(url), 1000);
}
